import { render, staticRenderFns } from "./IFrameSnippet.vue?vue&type=template&id=d0ced628&scoped=true&"
import script from "./IFrameSnippet.vue?vue&type=script&lang=js&"
export * from "./IFrameSnippet.vue?vue&type=script&lang=js&"
import style0 from "./IFrameSnippet.vue?vue&type=style&index=0&id=d0ced628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ced628",
  null
  
)

export default component.exports